import { Outlet } from "react-router-dom";
import { useAuthStore } from "../../store/auth.js";

export function ApplicantShell() {
  const authenticated = useAuthStore((s) => s.authenticated);
  const logout = useAuthStore((s) => s.logout);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2.5">
            <img src="/mantle-symbol.svg" alt="" aria-hidden className="size-8" />
            <div>
              <div className="text-sm font-semibold tracking-[0.14em] text-foreground">MANTLE</div>
              <div className="font-mono text-[9px] tracking-[0.12em] text-muted-foreground uppercase">
                Careers
              </div>
            </div>
          </div>
          {authenticated && (
            <button
              onClick={logout}
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              Sign out
            </button>
          )}
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
